<form [formGroup]="signatureForm" class="full-width dqf-sign" (ngSubmit)="onSubmit()" data-test="signature-form" data-testid="dqf-signature-form">
  <div class="content">
    <div class="fields-container">
      <div class="field-group" data-test="initials" data-testid="dqf-initials">
        <label class="form-field-label">Initials</label>
        <mat-form-field class="form-field-input" appearance="outline">
          <input matInput formControlName="initial" aria-autocomplete="none" autocomplete="off" required data-testid="dqf-initials-input" />
        </mat-form-field>
      </div>

      <div class="field-group">
        <label class="form-field-label">Date</label>
        <mat-form-field class="form-field-input" appearance="outline">
          <input matInput formControlName="date" required readonly data-testid="dqf-signature-date" />
        </mat-form-field>
      </div>
    </div>
    
    <div class="description">
      This certifies that this application was completed by me, and that all entries on it and information in it are
      true and complete to the best of my knowledge.
    </div>
    
    <div class="button-container">
      <button mat-raised-button type="submit" color="primary"
        [disabled]="!signatureForm.valid || signatureForm.pristine || isClicked" class="save-button"
        data-test="send-for-approval"
        data-testid="dqf-send-for-approval">
        Send for approval
      </button>
    </div>
  </div>
</form>